import { CompaniesResponseModel } from "../../../Models/ResponseModel/CompanyResponseModel";
import { FiscalPeriodResponseModel } from "../../../Models/ResponseModel/FiscalPeriodResponseModel";
import { SelectedFiscalPeriodStateModel } from "../../../Models/StateModel/FiscalPeriodInfoStateModel";
import { BaseAction, RootAction } from "../../Actions/RootAction";

const initialState = {
    companiesModel: null,
    fiscalPeriodModel: null,
    isActiveControl: true,
    selectedFiscalPeriodInfo: null
}

const mainPage = (state = initialState, action) => {
    let response = new BaseAction(action);

    switch (response.type) {
        case RootAction.MainPage.GetCompanies:
            if (!response.data) return initialState;
            let companies = new CompaniesResponseModel(response.data);
            return {
                ...state,
                companiesModel: companies
            }
        case RootAction.MainPage.GetOperableFiscalPeriods:
            if (!response.data) return initialState;
            if (response.statusCode === 200) {
                let model = new FiscalPeriodResponseModel(response.data);
                return {
                    ...state,
                    fiscalPeriodModel: model
                }
            }
            return {
                ...state
            }

        case RootAction.MainPage.SetSelectedFiscalPeriodInfo:
            return {
                ...state,
                selectedFiscalPeriodInfo: new SelectedFiscalPeriodStateModel(response.data)
            }

        default:
            break;
    }
    return state;
}

export default mainPage;

